import { render, staticRenderFns } from "./brandPage.vue?vue&type=template&id=5b4815df&scoped=true&"
import script from "./brandPage.vue?vue&type=script&lang=js&"
export * from "./brandPage.vue?vue&type=script&lang=js&"
import style0 from "./brandPage.vue?vue&type=style&index=0&id=5b4815df&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4815df",
  null
  
)

export default component.exports